<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "EducationsStore",
  components: {FooterPage, NavbarPage, LoadingPage},

  setup() {

    let loading = ref(false)

    let cat_name = ref(useRoute().params.cat_name)
    let cat_id = useRoute().params.cat_id

    let educations = ref([])

    function load_educations() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'educations', category_id: cat_id}, 'education', true).then((result) => {

        loading.value = false
        let res = result.data
        educations.value = res

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_educations)
      })
    }

    load_educations()

    return {

      loading,
      cat_name,
      educations,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">{{ cat_name }}</p>

        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="educations.length == 0" class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-4 ">
          در حال حاضر محصولی وجود ندارد...
        </p>
      </div>
    </div>


    <div v-else class="p-body mt-2">

      <router-link v-for="item in educations" :key="item.id"
                   class="animate__animated animate__fadeIn rounded-shaped d-flex flex-row-reverse justify-content-between text-black text-decoration-none mb-2 py-3 rounded-4 shadow-costom p-body"
                   :to="{name:'DetailsEducation' , params:{id:item.id}}">

        <div style="width: calc(100% - 10.5rem);" class="information_products">

          <p class="font-4 font-bold ">{{ item.name }}</p>

          <p class="font-4 d-flex">
            <span>{{ item.course_length }}</span>
            &nbsp;
            <span>
           ساعت
         </span>
          </p>
          <hr>
          <div class="price_div d-flex justify-content-between align-items-center">

            <div class="d-flex">

              <p class="m-0 ml-1"
                 :class="item.off_price == null ? 'font-color font-4' : 'text-decoration-line-through font-5' ">
                <span class="ml-1">{{ parseInt(item.price).toLocaleString() }}</span>
                <span v-if="item.off_price == null " class="">تومان</span>
              </p>

              <p v-if="item.off_price != null" class="font-4 font-color m-0 ml-1">
                <span class="ml-1">{{ parseInt(item.off_price).toLocaleString() }}</span>
                <span class="">تومان</span>
              </p>

            </div>

            <p v-if="item.off_price != null && item.discount != 0 "
               class="off_percent font-6 rounded-pill font-color p-1 m-0">
              <span>{{ item.discount }}</span>
              <span>%</span>
            </p>
          </div>
        </div>

        <div class="div_img_products rounded-4 animated-background position-relative ">
          <img class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
        </div>
      </router-link>

    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>
    <div class="rounded-4 bg-white font-bold font-color p-3 mb-3 w-75 ma-auto"> آموزش های {{ cat_name }}</div>

    <div style="height: 75vh" class="ma-auto overflow-y-scroll bg-white p-3 rounded-4 list_products_web w-75">

      <div v-if="educations.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 100px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p class="font-3">
            در حال حاضر محصولی وجود ندارد...
          </p>
        </div>
      </div>

      <!--*** محصولات ***-->
      <router-link v-else v-for="item in educations" :key="item.id"
                   class="animate__animated animate__fadeIn products_custom_web rounded-shaped d-flex flex-row-reverse justify-content-between text-black text-decoration-none mb-2 py-3 rounded-4 shadow-costom p-body"
                   :to="{name:'DetailsEducation' , params:{id:item.id}}">
        <div style="width: calc(100% - 11rem);" class="information_products d-flex flex-column justify-space-around">

          <p class="font-4 font-bold ">{{ item.name }}</p>

          <p class="font-4 d-flex">
            <span>{{ item.course_length }}</span>
            &nbsp;
            <span>
           ساعت
         </span>
          </p>

          <hr>

          <div class="price_div d-flex justify-content-between align-items-center">

            <div class="d-flex">

              <p class="m-0 ml-1"
                 :class="item.off_price == null ? 'font-color font-4' : 'text-decoration-line-through font-5' ">
                <span class="ml-1">{{ parseInt(item.price).toLocaleString() }}</span>
                <span v-if="item.off_price == null " class="">تومان</span>
              </p>

              <p v-if="item.off_price != null" class="font-4 font-color m-0 ml-1">
                <span class="ml-1">{{ parseInt(item.off_price).toLocaleString() }}</span>
                <span class="">تومان</span>
              </p>

            </div>

            <p v-if="item.off_price != null && item.discount != 0 "
               class="off_percent font-6 rounded-pill font-color p-1 m-0">
              <span>{{ item.discount }}</span>
              <span>%</span>
            </p>
          </div>
        </div>

        <div class="div_img_products_web rounded-4 animated-background position-relative">
          <img class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
        </div>
      </router-link>

    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.img_products {
  width: 100%;
  height: 122px;
}

.div_img_products {
  width: 10rem;
  margin-left: .8rem;
  height: 10rem;
}

.information_products {
  direction: rtl;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.off_percent {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d2d2d2;
}


.list_products_web {
  display: flex;
  justify-content: space-between;
  padding: 0 2%;
  flex-wrap: wrap;
}

.products_custom_web {
  padding: 12px 7px 12px 7px;
  border-radius: 15px;
  background-color: white;
  flex-basis: 48.5%;
  flex-grow: 0;
  height: fit-content;
}

.div_img_products_web {
  width: 10rem;
  height: 10rem;
  margin-left: .8rem;
}

</style>